import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { FormInput } from "../../components/atoms/form/text/FormInput";

export const OnboardingFormStep2Address = ({
  onboardingSettings,
}: {
  onboardingSettings: ClubOnboardingSettingsDTO;
}) => {
  const { t } = useTranslation();
  return (
    <motion.div
      className="flex w-full max-w-lg flex-col gap-3"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <div className="dark:text-gray-0 font-semibold text-gray-950">
        {t("pages.onboarding.addressDetails")}
      </div>
      <div className="flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-800 dark:bg-gray-900">
        {onboardingSettings.addressSetting !== "DISABLED" && (
          <>
            <FormInput
              name="addressLine1"
              label={t("pages.onboarding.addressLine1")}
              isRequired={onboardingSettings.addressSetting === "REQUIRED"}
              placeholder={t("pages.onboarding.addressLine1")}
            />
            <FormInput
              name="addressLine2"
              label={t("pages.onboarding.addressLine2")}
              placeholder={t("pages.onboarding.addressLine2")}
            />
          </>
        )}
        {onboardingSettings.citySetting !== "DISABLED" && (
          <FormInput
            name="city"
            label={t("pages.onboarding.city")}
            isRequired={onboardingSettings.citySetting === "REQUIRED"}
            placeholder={t("pages.onboarding.city")}
          />
        )}
        {onboardingSettings.postCodeSetting !== "DISABLED" && (
          <FormInput
            name="postCode"
            label={t("pages.onboarding.postCode")}
            isRequired={onboardingSettings.postCodeSetting === "REQUIRED"}
            placeholder={t("pages.onboarding.postCode")}
          />
        )}
      </div>
    </motion.div>
  );
};
